import * as React from "react";
import Head from "next/head";

interface Props {
  title: string;
}

const HeadComponent: React.FC<Props> = ({ title }) => {
  return (
    <Head>
      <title>{title}</title>
      <link rel="icon" href="/favicon/twt-mark.ico" sizes="any" />
      <link rel="icon" href="/favicon/twt-mark-adaptive.svg" type="image/svg+xml" />
      <meta name="msapplication-TileColor" content="#333333" />
      <meta name="theme-color" content="#333333"></meta>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1"
        // content="width=device-width, initial-scale=0.5, maximum-scale=0.5, user-scalable=yes"
      ></meta>
    </Head>
  );
};

export default HeadComponent;
